module.exports = __webpack_public_path__ + "img/backhoe_stopped.602bba71.svg";